var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.761 5.57h-.24v-.04c0-1.68 0-3.76-3.76-3.76h-1.52c-3.76 0-3.76 2.09-3.76 3.76v.05h-.24c-2.07 0-3.48.47-4.33 1.41-.99 1.1-.96 2.58-.86 3.59l.01.07.077.812a.5.5 0 0 0 .223.37c.381.251.675.433.88.548.14.09.29.17.44.25 1.71.94 3.59 1.57 5.5 1.88.09.94.5 2.04 2.69 2.04s2.62-1.09 2.69-2.06c2.04-.33 4.01-1.04 5.79-2.08.06-.03.1-.06.15-.09.46-.26.94-.59 1.36-.9l.04-.36.05-.47c.01-.06.01-.11.02-.18.08-1.01.06-2.39-.88-3.43-.85-.94-2.27-1.41-4.33-1.41zm-4.9 9.48c-1.23 0-1.23-.19-1.23-1.21v-1.26h2.46v1.25c0 1.06 0 1.22-1.23 1.22zm-2.95-9.52c0-1.7 0-2.33 2.33-2.33h1.52c2.33 0 2.33.64 2.33 2.33v.05h-6.18v-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.24 18.19c-.21 2-1.03 4.04-5.43 4.04H8.19c-4.4 0-5.22-2.04-5.43-4.03l-.341-3.752a.5.5 0 0 1 .707-.5c2.16.995 3.764 1.606 4.814 1.833.55 1.46 1.91 2.24 3.93 2.24 2 0 3.38-.81 3.93-2.27 1.24-.267 3.2-1.07 5.88-2.407l-.44 4.847z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBriefcase);
export default __webpack_public_path__ + "static/media/vuesax-bold-briefcase.9fe6feaf001f932e92efb1c251e4df2b.svg";
export { ForwardRef as ReactComponent };